module.exports = __webpack_public_path__ + "img/wireframes.bd9c361d.png";